import { Navigate } from 'react-router-dom';

export default function RoleRoute({ children, allowedRoles }) {
  const userRole = localStorage.getItem('role');
  
  if (!allowedRoles.includes(userRole)) {
    return <Navigate to="/unauthorized" />;
  }
  return <>{children}</>;
}

